import { optionSubcategory_people_view } from './viewSubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import DisplayByOption from 'owa-people-displayby-option/lib/DisplayByOption';

let viewSubCategory: OptionSubCategory = {
    key: 'viewActions',
    titleStringKey: optionSubcategory_people_view,
    options: [DisplayByOption],
};

export default viewSubCategory;
